var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperativeNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.75L11.6895 1.9395C11.4083 1.65818 11.0268 1.50008 10.629 1.5H4.5C4.10218 1.5 3.72064 1.65804 3.43934 1.93934C3.15804 2.22064 3 2.60218 3 3V15C3 15.3978 3.15804 15.7794 3.43934 16.0607C3.72064 16.342 4.10218 16.5 4.5 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0337 9.46961C16.3325 9.17085 16.5003 8.76563 16.5003 8.34311C16.5003 7.92059 16.3325 7.51538 16.0337 7.21661C15.735 6.91785 15.3297 6.75 14.9072 6.75C14.4847 6.75 14.0795 6.91785 13.7807 7.21661L10.7732 10.2256C10.5949 10.4038 10.4644 10.6241 10.3937 10.8661L9.76598 13.0186C9.74715 13.0831 9.74603 13.1516 9.76271 13.2167C9.77939 13.2818 9.81328 13.3412 9.86081 13.3888C9.90835 13.4363 9.96779 13.4702 10.0329 13.4869C10.098 13.5036 10.1664 13.5024 10.231 13.4836L12.3835 12.8559C12.6255 12.7852 12.8458 12.6547 13.024 12.4764L16.0337 9.46961Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.5H6.75",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperativeNote);
export default __webpack_public_path__ + "static/media/OperativeNote.166931f2867b2c54be8e95304658fab4.svg";
export { ForwardRef as ReactComponent };